import { Directive, forwardRef, Attribute } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { AbstractMomentValidator } from './moment.abstract.validator';
import { Moment } from 'moment';

@Directive({
    selector: '[validateAfter][formControlName],[validateAfter][formControl],[validateAfter][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MomentAfterValidator),
            multi: true
        }
    ],
    standalone: false
})
export class MomentAfterValidator extends AbstractMomentValidator {
  constructor(@Attribute('validateAfter') public validateAfter: string) {
    super(validateAfter);
  }

  compareValues(a: Moment, b: Moment): { [key: string]: any } {
    if (!a.isAfter(b)) {
      return {
        validateAfter: true
      };
    }

    return null;
  }

  clearTargetErrors(e: any) {
    delete e.errors['validateAfter'];
  }
}
